import React, { useState, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEye, faSave, faExclamationTriangle, faCheckDouble, faClock, faTag, faMapMarkerAlt, faStethoscope, faFlask, faPaw } from '@fortawesome/free-solid-svg-icons'
import { Paginador } from '../Paginacion/Paginador'
import { useAuthServices } from '../../services/useFetch';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardBody, CardHeader, CardTitle, Badge } from 'reactstrap';

const Servicios = () => {
    const { requestPost } = useAuthServices();

    const [menu, setMenu] = useState([
        { element: 'buttom1', label: 'Mis servicios', icon: faEye, class: 'btn btn-link p-menu-selector-agenda-active', state: true },
        { element: 'buttom2', label: 'Nuevo Registro', icon: faPlus, class: 'btn btn-link p-menu-selector-agenda', state: false },
    ])

    const [modalError, setModalError] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [executeConsulta, setExecuteConsulta] = useState(false);
    const [paginacion, setPaginacion] = useState({
        totalElementos: '0',
        elementosPorPagina: '6',
        paginaActual: '1'
    });

    const [modalValidation, setModalValidation] = useState(false);
    const [msgModal, setMsgModal] = useState('');
    const [listaServicios, setListaServicios] = useState([]);

    const [formData, setFormData] = useState({
        nombreServicio: '',
        descripcion: '',
        duracion: '',
        precio: '',
        modalidad: '',
        ubicacion: '',
        requisitos: '',

        especialidadMedica: '',
        tipoConsulta: '',
        cobertura: '',

        tipoServicioEstetico: '',
        materiales: '',
        nivelExperiencia: '',

        tipoAtencionVeterinaria: '',
        especie: '',
        recomendaciones: ''
    })

    const {
        nombreServicio, descripcion, duracion, precio, modalidad,
        ubicacion, requisitos,
        especialidadMedica, tipoConsulta, cobertura,
        tipoServicioEstetico, materiales, nivelExperiencia,
        tipoAtencionVeterinaria, especie, recomendaciones
    } = formData

    const obtieneListadoServicios = useCallback(async () => {
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
            const body = {
                idCompany: usuarioLocalStorageObj.idCompany
            };
            const response = await requestPost(body, 17);
            if (!response.error) {
                const { estado, objeto } = response.data;
                if (estado) {
                    setListaServicios(objeto || []);
                    setPaginacion(prev => ({
                        ...prev,
                        totalElementos: (objeto || []).length.toString()
                    }));
                }
            }
        }
    }, []);

    useEffect(() => {
        obtieneListadoServicios();
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.nombreServicio) {
            setModalValidation(true);
            return;
        }

        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
            const body = {
                ...formData,
                idCompany: usuarioLocalStorageObj.idCompany
            };

            const response = await requestPost(body, 16);
            if (!response.error) {
                const { estado, mensaje } = response.data;
                if (estado) {
                    setModalSuccess(true);
                    setFormData({
                        nombreServicio: '',
                        descripcion: '',
                        duracion: '',
                        precio: '',
                        modalidad: '',
                        ubicacion: '',
                        requisitos: '',
                        especialidadMedica: '',
                        tipoConsulta: '',
                        cobertura: '',
                        tipoServicioEstetico: '',
                        materiales: '',
                        nivelExperiencia: '',
                        tipoAtencionVeterinaria: '',
                        especie: '',
                        recomendaciones: ''
                    });
                    obtieneListadoServicios();
                } else {
                    setMsgModal(mensaje);
                    setModalError(true);
                }
            } else {
                setMsgModal('Error de comunicación. Por favor intenta más tarde.');
                setModalError(true);
            }
        }
    }

    const executeMenu = (e) => {
        setMenu((elements) => {
            const hMap = elements.map((element) => {
                element.class = (e.target.name === element.element) ? 'btn btn-link p-menu-selector-agenda-active' : 'btn btn-link p-menu-selector-agenda'
                element.state = (e.target.name === element.element) ? true : false
                return element
            })
            return hMap;
        });
    }

    const handleCloseError = () => setModalError(false);
    const handleCloseSuccess = () => setModalSuccess(false);
    const handleCloseValidation = () => setModalValidation(false);

    const getPaginatedServicios = () => {
        const indexPage = (parseInt(paginacion.paginaActual, 10) - 1) * parseInt(paginacion.elementosPorPagina, 10);
        const limitPage = indexPage + parseInt(paginacion.elementosPorPagina, 10);
        return (listaServicios || []).slice(indexPage, limitPage);
    };

    const displayMenu = () => {
        let object = {};
        menu.map((element) => {
            if (element.state) {
                object = element;
            }
            return object;
        })

        const usuarioApp = sessionStorage.getItem('usuarioApp');
        const usuario = usuarioApp ? JSON.parse(usuarioApp) : {};
        const tipoDeNegocio = usuario.tipoDeNegocio || '';

        switch (object.element) {
            case 'buttom1':
                return (
                    <>
                        <h4 className="mb-4">Nuestros servicios registrados:</h4>
                        <div className="row mt-3">
                            {listaServicios.length === 0 ? (
                                <div className="col-12 text-center py-5">
                                    <div className="div-container-no-data-agenda py-5">
                                        <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-muted mb-3" />
                                        <p className="p-label-form">No tienes servicios registrados aún.</p>
                                    </div>
                                </div>
                            ) : (
                                getPaginatedServicios().map((servicio, index) => (
                                    <div key={index} className="col-12 col-md-6 mb-4">
                                        <Card className="h-100 shadow-sm border-0" style={{ borderRadius: '15px' }}>
                                            <CardHeader className="bg-transparent border-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                                                <CardTitle tag="h5" className="mb-0 fw-bold" style={{ color: '#2d3748' }}>
                                                    {servicio.nombreServicio}
                                                </CardTitle>
                                                <Badge color="warning" className="p-2" style={{ borderRadius: '8px', color: '#856404', backgroundColor: '#fff3cd' }}>
                                                    ${servicio.precio || '0'}
                                                </Badge>
                                            </CardHeader>
                                            <CardBody>
                                                <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>{servicio.descripcion}</p>
                                                <div className="d-flex gap-3 mb-3 flex-wrap">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <FontAwesomeIcon icon={faClock} style={{ color: 'orange' }} />
                                                        <span style={{ fontSize: '0.85rem' }}>{servicio.duracion} min</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <FontAwesomeIcon icon={faTag} style={{ color: 'orange' }} />
                                                        <span style={{ fontSize: '0.85rem' }}>{servicio.modalidad}</span>
                                                    </div>
                                                    {servicio.ubicacion && (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: 'orange' }} />
                                                            <span style={{ fontSize: '0.85rem' }}>{servicio.ubicacion}</span>
                                                        </div>
                                                    )}
                                                </div>

                                                {tipoDeNegocio === 'NEGOCIO_1' && (
                                                    <div className="p-3 bg-light rounded-3" style={{ borderLeft: '4px solid #4a90e2' }}>
                                                        <h6 className="mb-2 fw-bold" style={{ fontSize: '0.85rem', color: '#4a90e2' }}>
                                                            <FontAwesomeIcon icon={faStethoscope} className="me-2" /> Detalles Médicos
                                                        </h6>
                                                        <div className="row g-2" style={{ fontSize: '0.8rem' }}>
                                                            <div className="col-6"><strong>Especialidad:</strong> {servicio.especialidadMedica}</div>
                                                            <div className="col-6"><strong>Consulta:</strong> {servicio.tipoConsulta}</div>
                                                            <div className="col-12"><strong>Cobertura:</strong> {servicio.cobertura || 'N/A'}</div>
                                                        </div>
                                                    </div>
                                                )}

                                                {tipoDeNegocio === 'NEGOCIO_2' && (
                                                    <div className="p-3 bg-light rounded-3" style={{ borderLeft: '4px solid #e83e8c' }}>
                                                        <h6 className="mb-2 fw-bold" style={{ fontSize: '0.85rem', color: '#e83e8c' }}>
                                                            <FontAwesomeIcon icon={faFlask} className="me-2" /> Detalles Estéticos
                                                        </h6>
                                                        <div className="row g-2" style={{ fontSize: '0.8rem' }}>
                                                            <div className="col-6"><strong>Tipo:</strong> {servicio.tipoServicioEstetico}</div>
                                                            <div className="col-6"><strong>Experiencia:</strong> {servicio.nivelExperiencia}</div>
                                                            <div className="col-12"><strong>Materiales:</strong> {servicio.materiales || 'N/A'}</div>
                                                        </div>
                                                    </div>
                                                )}

                                                {tipoDeNegocio === 'NEGOCIO_3' && (
                                                    <div className="p-3 bg-light rounded-3" style={{ borderLeft: '4px solid #28a745' }}>
                                                        <h6 className="mb-2 fw-bold" style={{ fontSize: '0.85rem', color: '#28a745' }}>
                                                            <FontAwesomeIcon icon={faPaw} className="me-2" /> Detalles Veterinarios
                                                        </h6>
                                                        <div className="row g-2" style={{ fontSize: '0.8rem' }}>
                                                            <div className="col-6"><strong>Atención:</strong> {servicio.tipoAtencionVeterinaria}</div>
                                                            <div className="col-6"><strong>Especie:</strong> {servicio.especie}</div>
                                                            <div className="col-12"><strong>Recms:</strong> {servicio.recomendaciones || 'Sin recomendaciones'}</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </CardBody>
                                        </Card>
                                    </div>
                                ))
                            )}
                        </div>
                        <Paginador
                            elementsPaginacion={paginacion}
                            setElementsPaginacion={setPaginacion}
                            setExecuteConsulta={setExecuteConsulta}
                            executeConsulta={executeConsulta}
                        />
                    </>
                )
            case 'buttom2':
                return (
                    <div className="">
                        <h5 className="mb-3 ">Información General</h5>
                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Nombre del servicio <span className="text-danger">*</span></label>
                                <input type="text" name="nombreServicio" className="form-control" value={nombreServicio} onChange={handleChange} placeholder="Ej: Consulta General" />
                            </div>
                            <div className="col-12 col-md-12 mb-3">
                                <label className="form-label">Descripción breve <span className="text-danger">*</span></label>
                                <textarea name="descripcion" className="form-control" value={descripcion} onChange={handleChange} rows="2"></textarea>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <label className="form-label">Duración (min) </label>
                                <input type="number" name="duracion" className="form-control" value={duracion} onChange={handleChange} placeholder="30" />
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <label className="form-label">Precio</label>
                                <input type="number" name="precio" className="form-control" value={precio} onChange={handleChange} />
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <label className="form-label">Modalidad</label>
                                <select name="modalidad" className="form-select" value={modalidad} onChange={handleChange}>
                                    <option value="">Seleccione...</option>
                                    <option value="Presencial">Presencial</option>
                                    <option value="Virtual">Virtual</option>
                                </select>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Dirección</label>
                                <input type="text" name="ubicacion" className="form-control" value={ubicacion} onChange={handleChange} />
                            </div>
                            <div className="col-12 col-md-12 mb-3">
                                <label className="form-label">Requisitos previos</label>
                                <input type="text" name="requisitos" className="form-control" value={requisitos} onChange={handleChange} />
                            </div>
                        </div>

                        {tipoDeNegocio === 'NEGOCIO_1' && (
                            <>
                                <hr />
                                <h5 className="mb-3">Detalles Medicina / Salud</h5>
                                <div className="row">
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Especialidad Médica</label>
                                        <input type="text" name="especialidadMedica" className="form-control" value={especialidadMedica} onChange={handleChange} />
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Tipo de Consulta</label>
                                        <select name="tipoConsulta" className="form-select" value={tipoConsulta} onChange={handleChange}>
                                            <option value="">Seleccione...</option>
                                            <option value="General">General</option>
                                            <option value="Especializada">Especializada</option>
                                            <option value="Seguimiento">Seguimiento</option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Cobertura de Seguros</label>
                                        <input type="text" name="cobertura" className="form-control" value={cobertura} onChange={handleChange} placeholder="Opcional" />
                                    </div>
                                </div>
                            </>
                        )}

                        {tipoDeNegocio === 'NEGOCIO_2' && (
                            <>
                                <hr />
                                <h5 className="mb-3">Detalles Belleza / Estética</h5>
                                <div className="row">
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Tipo de Servicio</label>
                                        <input type="text" name="tipoServicioEstetico" className="form-control" value={tipoServicioEstetico} onChange={handleChange} />
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Materiales Incluidos</label>
                                        <input type="text" name="materiales" className="form-control" value={materiales} onChange={handleChange} />
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Nivel de Experiencia</label>
                                        <select name="nivelExperiencia" className="form-select" value={nivelExperiencia} onChange={handleChange}>
                                            <option value="">Seleccione...</option>
                                            <option value="Junior">Junior</option>
                                            <option value="Senior">Senior</option>
                                            <option value="Experto">Experto</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        {tipoDeNegocio === 'NEGOCIO_3' && (
                            <>
                                <hr />
                                <h5 className="mb-3">Detalles Veterinaria</h5>
                                <div className="row">
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Tipo de Atención</label>
                                        <select name="tipoAtencionVeterinaria" className="form-select" value={tipoAtencionVeterinaria} onChange={handleChange}>
                                            <option value="">Seleccione...</option>
                                            <option value="Consulta">Consulta</option>
                                            <option value="Vacunación">Vacunación</option>
                                            <option value="Cirugía">Cirugía Menor</option>
                                            <option value="Peluquería">Peluquería</option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Especie</label>
                                        <input type="text" name="especie" className="form-control" value={especie} onChange={handleChange} placeholder="Perros, Gatos..." />
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label">Recomendaciones Post-servicio</label>
                                        <input type="text" name="recomendaciones" className="form-control" value={recomendaciones} onChange={handleChange} />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="div-buton-registra-cliente mt-4" >
                            <button className='bottom-custom-secondary' onClick={handleSubmit}>
                                <FontAwesomeIcon icon={faSave} /> Guardar
                            </button>
                        </div>
                    </div>
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className='div-container-db-agenda' >
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                        <div className=''>
                            <h1 className='size-db-info-agenda-h1'>
                                Administra tus servicios:
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="">
                    <p className='p-label-form mt-3'>Crea, edita y gestiona tus servicios para el agendamiento de citas.</p>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-2" ></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8" >
                        <div className="div-menu-selector-agenda-container">
                            <div className="div-menu-selector-agenda">
                                {
                                    menu.map((object, index) => {
                                        return (
                                            <button key={index} name={object.element} className={object.class} onClick={executeMenu} >
                                                <FontAwesomeIcon icon={object.icon} /> {object.label}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-2" ></div>
                </div>
            </div>
            <div className='div-container-db-agenda mt-2'>
                {
                    displayMenu()
                }
            </div >

            {/* Modals for feedback */}
            <Modal isOpen={modalValidation} toggle={handleCloseValidation} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseValidation}>
                    <h4>Información incompleta <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' style={{ color: 'orange' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>Por favor complete los campos obligatorios (*).</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseValidation}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalError} toggle={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseError}>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' style={{ color: 'red' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>{msgModal || 'Vaya, tenemos algunas dificultades de comunicación. Por favor intenta más tarde.'}</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseError}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalSuccess} toggle={handleCloseSuccess} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseSuccess}>
                    <h4>Servicio Registrado <FontAwesomeIcon icon={faCheckDouble} className='icon-success' style={{ color: 'green' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>¡Excelente! El servicio ha sido registrado exitosamente.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseSuccess}>Aceptar</Button></ModalFooter>
            </Modal>
        </>
    )
}

export default Servicios